import { render, staticRenderFns } from "./GoButton.vue?vue&type=template&id=e65d4a4a&"
import script from "./GoButton.vue?vue&type=script&lang=js&"
export * from "./GoButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports